import React from 'react';
import { useRecentCareSources } from '../../features/careSourceProcessing/useRecentCareSources';
import PendingAppointmentTimelineSection from '../../features/appointments/PendingAppointmentTimelineSection';
import {
  buildPendingAppointmentCalendarEntries,
  buildPendingAppointmentTimelineCandidates,
  getPendingAppointmentsForDate,
} from '../../features/appointments/appointmentTimelineCandidates';
import { getPendingTimelineCaptures } from '../../features/careSourceProcessing/pendingTimelineCaptures';
import PendingCaptureTimelineSection from '../../features/careSourceProcessing/PendingCaptureTimelineSection';

const useTimelineSourceSections = ({ child, userRole, selectedDateKey, entries, onReviewAppointment }) => {
  const { sources } = useRecentCareSources({
    childId: child?.id || '', includeAllMatching: true, notifyTimelineChanges: true,
  });
  const pendingAppointments = React.useMemo(() => (
    ['care_owner', 'care_partner'].includes(userRole)
      ? buildPendingAppointmentTimelineCandidates(sources, { timeZone: child?.timeZone || child?.timezone || '' })
      : []
  ), [sources, userRole, child?.timeZone, child?.timezone]);
  const appointments = React.useMemo(() => (
    getPendingAppointmentsForDate(pendingAppointments, selectedDateKey)
  ), [pendingAppointments, selectedDateKey]);
  const pendingAppointmentCalendarEntries = React.useMemo(() => (
    buildPendingAppointmentCalendarEntries(pendingAppointments)
  ), [pendingAppointments]);
  const captures = React.useMemo(() => getPendingTimelineCaptures({
    sources, entries, childId: child?.id || '', dateKey: selectedDateKey, viewerRole: userRole,
  }), [sources, entries, child?.id, selectedDateKey, userRole]);

  return {
    pendingAppointmentCalendarEntries,
    hasPendingContent: appointments.length > 0 || captures.length > 0,
    sections: <>
      <PendingCaptureTimelineSection sources={captures} />
      <PendingAppointmentTimelineSection appointments={appointments} onReview={onReviewAppointment} />
    </>,
  };
};

export default useTimelineSourceSections;
